import clsx from 'clsx'
import NextImage, { type ImageProps } from 'next/image'
import Link from 'next/link'
import { type ReactNode } from 'react'
import { Heading } from 'ui/src/components/Heading/Heading'
import { Text } from 'ui/src/components/Text/Text'
import { yStack } from 'ui/src/patterns/stack'
import { sprinkles } from 'ui/src/theme/sprinkles.css'
import { makeAbsolute } from '@/utils/url'
import { contentWrapper, clampedText, extendedLink, roundedImage } from './ArticleTeaser.css'

type Props = {
  children: ReactNode
  title: string
  ingress: string
  href: string
  date: string
}

const Root = (props: Props) => {
  return (
    <div className={yStack({ position: 'relative', gap: 'md' })}>
      <div className={yStack({ gap: 'md' })}>
        {props.children}
        <div className={contentWrapper}>
          <Text size="sm" color="textSecondary" uppercase={true}>
            {props.date}
          </Text>
        </div>
      </div>
      <div className={contentWrapper}>
        <div className={clampedText}>
          <Link className={extendedLink} href={makeAbsolute(props.href)} style={{ display: 'block' }}>
            <Heading as="h3" variant="standard.20">
              {props.title}
            </Heading>
          </Link>
          {/* We can't use flex to space heading and paragraph texts while making them clamped */}
          <Text className={sprinkles({ mt: 'xxs' })} as="p" size="lg" color="textSecondary">
            {props.ingress}
          </Text>
        </div>
      </div>
    </div>
  )
}

const Image = ({ className, ...forwardedProps }: ImageProps) => (
  <NextImage className={clsx(roundedImage, className)} {...forwardedProps} />
)

export const ArticleTeaser = {
  Root,
  Image,
} as const
